import { ajvResolver } from '@hookform/resolvers/ajv'
import AccountCircle from '@mui/icons-material/AccountCircle'
import { Box, Button, Container, Divider, Paper, TextField, Typography } from '@mui/material'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useAuth } from 'contexts/auth'
import { IUserDTO } from 'data/dtos/security/i-user-dto'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import ProfileSchema, { IProfileFormData } from 'schema/authentication/profile'
import api from 'services/api'
import { useStyles } from './styles'

const Profile = () => {
  const [mainError, setMainError] = useState('')

  const classes = useStyles()

  const fileInputRef = useRef<any>(null)

  const { user, updateUserData, updateUser } = useAuth()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IProfileFormData>({
    resolver: ajvResolver(ProfileSchema),
    defaultValues: {
      name: '',
      password: '',
    },
  })

  useEffect(() => {
    async function loadData() {
      await api
        .get(`/users/profile`)
        .then((res) => {
          const { data } = res.data

          const profileResult = {
            name: data.name,
          }

          return profileResult
        })
        .then((profileResult) => {
          reset(profileResult)
        })
        .catch((err) => console.log(err))
    }

    loadData()
  }, [])

  const onSubmit = useCallback(async (data: IProfileFormData) => {
    try {
      const payload: IUserDTO = {
        name: data.name,
      }

      if (data.password && data.password != '') {
        payload.password = data.password
      }

      await api.patch('/users/profile', payload)

      await updateUserData()
    } catch (error) {
      console.log(error)
    }
  }, [])

  const handleChange = (formField: any) => {
    setMainError('')
  }

  const handleFileChange = async (event: any) => {
    const avatar = event.target.files[0]

    const formData = new FormData()
    formData.append('avatar', avatar)

    await api
      .patch('/users/avatar', formData)
      .then((res) => {
        const { data: avatarUrl } = res.data
        if (!user) {
          return
        }

        updateUser({
          id: user.id,
          name: user.name,
          email: user.email,
          avatar_url: avatarUrl,
        })
      })
      .catch((err) => console.log(err))
  }

  const handleLabelClick = () => {
    fileInputRef.current.click()
  }

  useEffect(() => {
    console.log(errors)
  }, [errors])

  return (
    <WrapperWithHeader>
      <Paper
        elevation={3}
        className={classes.paper}
      >
        <Container
          maxWidth='md'
          className={classes.avatarContainer}
          onClick={handleLabelClick}
        >
          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            {user && user.avatar_url ? (
              <img
                src={user.avatar_url}
                className={classes.profileImage}
              />
            ) : (
              <AccountCircle
                sx={{ fontSize: '200px' }}
                color='primary'
              />
            )}

            <Typography variant='h6'>Clique para enviar uma imagem</Typography>
          </Box>

          <input
            accept='.jpg,.jpeg,.png'
            type='file'
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </Container>

        <Container maxWidth='md'>
          <Divider
            variant='fullWidth'
            className={classes.divider}
          />
        </Container>

        <Container
          maxWidth='md'
          component='form'
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          data-testid='form'
        >
          <Box
            display='flex'
            flexDirection='column'
            gap={2}
          >
            <Typography variant='h4'>Informações básicas</Typography>

            <TextField
              id='name'
              autoComplete='none'
              label='Nome'
              error={!!errors.name}
              helperText={errors?.name?.message}
              variant='outlined'
              margin='dense'
              size='small'
              fullWidth={true}
              InputProps={{
                style: { height: '3em' },
              }}
              InputLabelProps={{
                shrink: true,
                style: { backgroundColor: '#D4DAED' },
              }}
              inputProps={{
                maxLength: 100,
              }}
              {...register('name', { onChange: (e) => handleChange(e) })}
            />

            <TextField
              id='password'
              autoComplete='none'
              label='Senha'
              error={!!errors.password}
              helperText={errors?.password?.message}
              variant='outlined'
              margin='dense'
              size='medium'
              type='password'
              fullWidth={true}
              InputProps={{
                style: { height: '3em' },
              }}
              InputLabelProps={{
                shrink: true,
                style: { backgroundColor: '#D4DAED' },
              }}
              inputProps={{
                maxLength: 100,
              }}
              {...register('password', { onChange: (e) => handleChange(e) })}
            />

            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
            >
              <Button
                type='submit'
                variant='contained'
                color='primary'
              >
                Salvar
              </Button>
            </Box>
          </Box>
        </Container>
      </Paper>
    </WrapperWithHeader>
  )
}

export default Profile
